import { Component, OnInit } from '@angular/core';
import { Constants } from 'src/app/shared/constants/constants.constant';
import { AppContextService } from 'src/app/core/services/app-context.service';
import { SecurityService } from 'src/app/core/services/security.service';

@Component({
	selector: 'app-access-denied',
	templateUrl: './access-denied.component.html',
	standalone: false,
})
export class AccessDeniedComponent implements OnInit {
	constructor(
		private appContext: AppContextService,
		private securityService: SecurityService
	) {
		this.appContext.ViewTitle = 'Access Denied';
		this.appContext.BasePageCSSClass.set(Constants.BasePageCSSClass.Default);
	}
	ngOnInit(): void {
		this.securityService.updateCurrentUser(false).subscribe();
	}
}
